import { FilterType, MedicationFormEnums } from "src/api/types";
import PharmacyFilter from "src/components/PharmacyFilter";
import TreatmentFilter from "src/components/TreatmentFilter";
import {
  DISPENSE_UNIT,
  MEDICATION_FORM,
  MEDICATION,
  PHARMACY,
  TREATMENT,
  DOSAGE,
  GENDER,
} from "src/constants/searchParams";

export const filters: FilterType[] = [
  {
    name: PHARMACY,
    placeholder: "Pharmacy",
    type: "custom",
    component: PharmacyFilter,
  },
  {
    name: MEDICATION_FORM,
    placeholder: "Form",
    type: "select",
    values: MedicationFormEnums,
  },
  {
    name: TREATMENT,
    placeholder: "Treatment",
    type: "custom",
    component: TreatmentFilter,
  },
  {
    name: GENDER,
    placeholder: "Gender",
    type: "select",
    values: ["Male", "Female"],
  },
  {
    name: MEDICATION,
    placeholder: "Medication",
    type: "text",
  },
  {
    name: DISPENSE_UNIT,
    placeholder: "Dispense Unit",
    type: "select",
    values: ["vial", "tablet", "capsule", "serum"],
  },
  {
    name: DOSAGE,
    placeholder: "Dosage",
    type: "text",
  },
];
